import { Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setShowDemo } from "../services/store";
const YT_ID = "WIt_cOK8EIY";

const Demo = () => {
  const dispatch = useDispatch();
  const { showDemo } = useSelector((state) => state.grid);
  return (
    <Modal
      title="Demo"
      open={showDemo}
      onCancel={() => dispatch(setShowDemo(false))}
      footer={null}
      destroyOnHidden
      width={600}
      centered
    >
      <div className="h-[500px] w-full">
        <iframe
          title="Grid Demo"
          width="100%"
          height="100%"
          src={`https://www.youtube.com/embed/${YT_ID}?autoplay=1`}
          allow="autoplay; encrypted-media"
          allowFullScreen
        />
      </div>
    </Modal>
  );
};

export default Demo;
